import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FirmwareUpdateStore } from '@store';
import { isEqual } from 'lodash';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-firmware-update-progress',
  templateUrl: './firmware-update-progress.component.html',
  styleUrls: ['./firmware-update-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateProgressComponent implements OnInit, OnDestroy {
  @Input() gatewaySerial: string;

  private maxProgress = 100;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public firmwareUpdateStore: FirmwareUpdateStore) {}

  ngOnInit(): void {
    this.firmwareUpdateStore.overallProgress$
      .pipe(distinctUntilChanged(isEqual), takeUntil(this.ngUnsubscribe))
      .subscribe((overallProgress: number) => {
        if (overallProgress < this.maxProgress) {
          this.saveProgressToLocal();
        }
      });
  }

  private saveProgressToLocal(): void {
    this.firmwareUpdateStore.saveLocalStorageFirmwareUpdateState(this.gatewaySerial);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.firmwareUpdateStore.clearLocalStorageKey(this.gatewaySerial);
  }
}
